import { gql } from "graphql-tag";

export const getTextBlockV2 = pageType => gql`
  fragment ${pageType}_Text_block_v2 on ${pageType}BodyText_block_v2 {
     type
     label
     variation {
      ... on ${pageType}BodyText_block_v2Default {
         primary {
            title
            description
         }
      }
   }
}`;
